import React, { useState, useEffect } from "react";
import EmptyContent from "./EmptyContent";
import Header from "./Header";

export default function Speakers({ event }) {
  const [speakers, setSpeakers] = useState([]);
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);

  useEffect(() => {
    if (!event?.event_slug) return;

    const token = localStorage.getItem("access");

    if (!token) {
      console.warn("No token yet — skipping speakers fetch");
      return;
    }

    fetch(`/api/events/${event.event_slug}/speakers/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error("Unauthorized");
        }
        return res.json();
      })
      .then(setSpeakers)
      .catch(() => {
        window.location.href = `/events/${event.event_slug}/signin`;
      });
  }, [event]);

  return (
    <>
      <Header />
      <div className="bg-gradient-to-b from-[#dceaf5] to-white">
        <div className="mx-auto max-w-7xl px-4 py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 ">
            {speakers && speakers.length > 0 ? (
              speakers.map((speaker) => (
                <div
                  key={speaker.id}
                  className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition"
                  onClick={() => setSelectedSpeaker(speaker)}
                >
                  <img
                    alt=""
                    src={speaker.image}
                    className="w-32 h-32 mx-auto rounded-full object-cover"
                  />

                  <h3 className="mt-4 text-center text-xl font-semibold text-gray-900">
                    {speaker.first_name} {speaker.last_name}
                  </h3>

                  <p className="text-center text-sm text-blue-600 font-medium">
                    {speaker.position}
                  </p>

                  <p className="text-center text-sm text-blue-600 font-medium">
                    {speaker.organization}
                  </p>

                  <p className="mt-3 text-gray-700 text-sm leading-relaxed">
                    {speaker.bio}
                  </p>
                </div>
              ))
            ) : (
              <EmptyContent
                title="Speakers"
                description="We're in the process of finalizing our lineup of speakers. Stay tuned for updates!"
              />
            )}
          </div>
        </div>
        {selectedSpeaker && (
          <div
            className="fixed inset-0 z-50 grid place-content-center bg-black/75 p-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modalTitle"
            onClick={() => setSelectedSpeaker(null)}
          >
            <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow-lg dark:bg-gray-900">
              <div className="flex items-start justify-between">
                <h2
                  id="modalTitle"
                  className="text-xl mb-3 font-bold text-gray-900 sm:text-2xl dark:text-white"
                >
                  {selectedSpeaker.first_name} {selectedSpeaker.last_name}
                </h2>
                <button
                  type="button"
                  className="-me-4 -mt-4 rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-50 hover:text-gray-600 focus:outline-none dark:text-gray-500 dark:hover:bg-gray-800 dark:hover:text-gray-300"
                  aria-label="Close"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="size-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </button>
              </div>
              <div>
                <img
                  src={selectedSpeaker.image}
                  alt={selectedSpeaker.first_name}
                  className="w-40 h-40 rounded-full object-cover text-left"
                />
                <p className="mt-3 text-pretty text-gray-700 dark:text-gray-200 font-bold">
                    {selectedSpeaker.position}, {selectedSpeaker.organization}
                  </p>
                <div className="mt-4">
                  <p className="text-pretty text-gray-700 dark:text-gray-200">
                    {selectedSpeaker.bio}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
